import ResponsiveWatcher, {ResponsiveSize} from "./classes/responsive-watcher";

export const debounce = <T extends (...args: any[]) => any>(
	callback: T,
	waitFor: number
) => {
	let timeout = 0;
	return (...args: Parameters<T>): ReturnType<T> => {
		let result: any;
		if (timeout) clearTimeout(timeout);
		timeout = setTimeout(() => {
			result = callback(...args);
		}, waitFor);
		return result;
	};
};

const elCache: {[key:string]:Element} = {};
const elsCache: {[key:string]:NodeListOf<Element>} = {};

/**
 * Helper Function to query dom elements. If the page isnt loaded yet, they are cached until it is loaded and then queried.
 * @param query
 */
export const getEl = function(query:string):Element {
	if (elCache.hasOwnProperty(query)) return elCache[query];
	elCache[query] = document.querySelector(query);
	return elCache[query];
};

export const getEls = function(query:string):NodeListOf<Element> {
	if (elsCache.hasOwnProperty(query)) return elsCache[query];
	elsCache[query] = document.querySelectorAll(query);
	return elsCache[query];
};

export const clearElCache = function() {
	for (let item in elCache)
	{
		delete(elCache[item]);
	}
	for (let item in elsCache)
	{
		delete(elsCache[item]);
	}
}


export const elementHeight = function(el:Element) {
	return Math.max(el.scrollHeight, el.clientHeight);
};
export const elementY = function(el:Element) {
	return el.getBoundingClientRect().top + window.scrollY;
};

export const delay = function(milliseconds:number):Promise<any> {
	return new Promise<any>((resolve,reject) => {
		setTimeout(() => {
			resolve(undefined);
		}, milliseconds);
	});
}

export const findParentEl = function(el:Element, query: string)
{
	if (!el.parentElement) return false;
	if (el.parentElement.matches(query)) return el.parentElement;
	return findParentEl(el.parentElement, query);
}


export const isSmallerThanOrEqualTo = function(size:ResponsiveSize, benchmark: ResponsiveSize)
{
	let aInd = ResponsiveWatcher.ordering.indexOf(size);
	let bInd = ResponsiveWatcher.ordering.indexOf(benchmark);
	if (aInd == -1 || bInd == -1) return false;
	
	return aInd <= bInd;
}

export const isGreaterThanOrEqualTo = function(size:ResponsiveSize, benchmark: ResponsiveSize)
{
	let aInd = ResponsiveWatcher.ordering.indexOf(size);
	let bInd = ResponsiveWatcher.ordering.indexOf(benchmark);
	if (aInd == -1 || bInd == -1) return false;
	
	return aInd >= bInd;
}


export const removeInlineStyles = function(selectorOrElement: String|Element)
{
	const el:Element = (typeof(selectorOrElement) == "string") ? getEl(selectorOrElement) : selectorOrElement as Element;
	if (!el) return;
	if (el.classList.contains('heading-piece')) return;
	
	el.removeAttributeNS(null, "style");
	el.removeAttribute("style");
	for (let i = 0; i < el.children.length; i++)
	{
		removeInlineStyles(el.children[i]);
	}
}


export const setDownloadReportURLPage = function(pageNumber:number|boolean)
{
	const el:HTMLElement = getEl('.download-report-button') as HTMLElement;
	if (el)
	{
		el.setAttribute('href', el.dataset.href + (typeof(pageNumber) === 'boolean' ? '#page=1' : '#page='+pageNumber));
	}
}


